import Select from 'react-select'
import deviceSelectStyles from './deviceSelectStyles.js'

/** One labeled device dropdown inside the popover. isSearchable is off —
 * device lists are a handful of entries, and a text input would pop the
 * keyboard on phones. The menu is NOT portaled: it must stay inside the
 * popover's DOM subtree so the popover's outside-click close can tell a menu
 * click from a real outside click. */
export default function DeviceSelect({ icon: Icon, label, inputId, options, value, onChange }) {
  return (
    <label className="block" htmlFor={inputId}>
      <span className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-white/50 mb-1.5">
        <Icon className="w-3 h-3 shrink-0" aria-hidden="true" /> {label}
      </span>
      <Select
        inputId={inputId}
        options={options}
        value={options.find((o) => o.value === value) ?? null}
        onChange={(opt) => opt && onChange(opt.value)}
        placeholder="System default"
        noOptionsMessage={() => 'No devices found'}
        isSearchable={false}
        menuPlacement="auto"
        styles={deviceSelectStyles}
      />
    </label>
  )
}
